import * as types from "./types"
import http from "@/utils/http"
import http_pay from "@/utils/http_pay"
// 轻提示
import { Toast } from 'vant';

let state = {
    noData: false,
    carList: [],
    parkList: [],
    storedValue: "未获取", // 当前储值余额
    belongMerberCarStr: "请选择车辆",
    belongParkStr: "请选择停车场",
    belongParkId: "",
    belongCarFixedId: "",
    // 充值相关数据
    queryData: {
        carNo: "",
        storedValueInput: "",
        belongParkId: ""
    }
}

// 异步任务
let actions = {
    [types.MERBERCARPUBLICQUERY](context, params) { // 我的车辆列表
      return http_pay.post('p-ypt-merberCarPublic-query', params).then(data => {
            console.log(state.carList,'---')
            context.commit(types.MERBERCARPUBLICQUERY, data)
            return data; // 返回数据以便组件处理
        })
    },
    [types.QUERYSTOREDCARS](context, params) { // 查询储值车辆列表
        http_pay.post('p-ypt-merberCarPublic-query', params).then(data => {
            context.commit(types.QUERYSTOREDCARS, data)
        })
    },
    
    [types.QUERYSTOREDPARKS](context, params) { // 查询储值停车场列表
        http_pay.post('p-ypt-parkingPay-query', params).then(data => {
            context.commit(types.QUERYSTOREDPARKS, data)
        })
    },
    
    [types.GETSTOREDVALUE](context, params) { // 获取储值余额
        http_pay.post('p-ypt-getStoredValue-query', params).then(data => {
            context.commit(types.GETSTOREDVALUE, data)
        })
    },
    
    [types.CREATESTOREDPAYORDER](context, params) { // 创建储值支付订单
        return http_pay.post('p-ypt-storedPay-add', params).then(data => {
            context.commit(types.CREATESTOREDPAYORDER, data)
            return data; // 返回数据以便组件处理
        })
    }
}

// 同步任务
let mutations = {
    [types.MERBERCARPUBLICQUERY](state, data) {
        if (data.code==='ok') {
            if (data.data.length >= 1) {
                state.carList = data.data
                console.log(state.carList,'---')
            } else {
                state.noData = true
            }
        } else {
            Toast(data.message)
        }
    },
    [types.RESETSTOREDDATA](state) {
        // 重置储值数据
        state.noData = false
        // state.carList = []
        state.parkList = []
        state.storedValue = "未获取"
        state.belongMerberCarStr = "请选择车辆"
        state.belongParkStr = "请选择停车场"
        state.belongParkId = ""
        state.belongCarFixedId = ""
        state.queryData = {
            carNo: "",
            storedValueInput: "",
            belongParkId: ""
        }
    },
    
    [types.SETSTOREDDATA](state, data) {
        // 设置储值数据
        Object.keys(data).forEach(key => {
            if (state.hasOwnProperty(key)) {
                state[key] = data[key]
            }
        })
    },
    
    [types.SETSTOREDBALANCE](state, balance) {
        console.log('SETSTOREDBALANCE called with:', balance)
        // 确保balance是字符串类型，并且不为空
        if (balance !== undefined && balance !== null) {
            state.storedValue = String(balance)
            console.log('storedValue updated to:', state.storedValue)
        } else {
            state.storedValue = '未获取'
            console.log('Invalid balance, storedValue set to default')
        }
    },
    
    [types.SETCARINFO](state, carInfo) {
        // 设置车辆信息
        state.belongMerberCarStr = carInfo.carNo || "请选择车辆"
        // 优先使用 fixedId，如果没有则使用 id
        state.belongCarFixedId = carInfo.fixedId || carInfo.id || ""
        state.queryData.carNo = carInfo.carNo || ""
    },
    
    [types.SETPARKINFO](state, parkInfo) {
        // 设置停车场信息
        state.belongParkStr = parkInfo.parkingGroupName || "请选择停车场"
        state.belongParkId = parkInfo.parkingGroupId || ""
        state.queryData.belongParkId = parkInfo.parkingGroupId || ""
        console.log(state.belongParkId,'---')
    },
    
    [types.QUERYSTOREDCARS](state, data) {
        if (data.code === 'ok') {
            if (data.data && data.data.length >= 1) {
                state.carList = data.data
                state.noData = false
            } else {
                state.noData = true
                Toast('暂无车辆信息')
            }
        } else {
            Toast(data.message || '获取车辆列表失败')
        }
    },
    
    [types.QUERYSTOREDPARKS](state, data) {
        if (data.code === 'ok') {
            state.parkList = data.data || []
        } else {
            Toast(data.message || '获取停车场列表失败')
        }
    },
    
    [types.GETSTOREDVALUE](state, data) {
        if (data.code !== 'ok') {
            Toast(data.message || '获取储值余额失败')
        }
    },
    
    [types.CREATESTOREDPAYORDER](state, data) {
        // 创建订单的 mutation 处理
        if (data.code !== 'ok') {
            Toast(data.message || '创建订单失败')
        }
    }
}

// 设置储值余额的便捷方法
export const setStoredValue = (store, value) => {
    store.commit(types.SETSTOREDBALANCE, value)
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/stored/index.js